import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";

/** Props Interface */
interface PaymentRunTransactionsCellProps {
	transactionCount: number;
}

/**
 * How many transfers the file carries — or, for a run whose payments were all settled by offset,
 * that it transferred nothing and has no file.
 */
export function PaymentRunTransactionsCell({ transactionCount }: PaymentRunTransactionsCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Guard */
	if (transactionCount > 0) return transactionCount;

	/** Render */
	return (
		<Tag
			size="xs"
			color="blue"
			variant="plain"
		>
			{t("incoming_invoices.payments.offsets.offset_only")}
		</Tag>
	);
}
